import { forwardRef, createElement } from 'react';

function IconChevronUp(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M17.53 13.97a.75.75 0 01-.976 1.133l-.084-.073L12 10.561l-4.47 4.47a.75.75 0 01-.976.072l-.084-.073a.75.75 0 01-.073-.976l.073-.084 5-5a.75.75 0 01.976-.073l.084.073 5 5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var ChevronUp = /*#__PURE__*/forwardRef(IconChevronUp);

export default ChevronUp;
//# sourceMappingURL=ChevronUp.js.map
